import { useEffect, useState, useContext, useRef} from 'react'
import {  useLocation, useParams } from "react-router-dom";
import * as icons from 'react-icons/md'

import { AppContext } from "../../Context";
import { Config } from "../../inc/Config";
import { Img, Tasks } from "../../components/Elements";

import Header from "./Header";
import Footer from "../Footer";


import './css/tasks.css'

export default function Main({children, main_article}) {

    const player = useRef();
    
    const location = useLocation();
    const split = location?.pathname?.split("/");

    const params = useParams();
    
    const {siteData} = useContext(AppContext); 
    const [data, setdata] = siteData;
    const [pos, setpos] = useState(false);
    

    const [playing, setplaying] = useState(true)

    let site = data?.cats?.filter(r => r?.name == params?.id);
    site = site?.length ? site[0] : {};
    
    
    function onScroll(e) {
        const { scrollTop, scrollHeight, clientHeight } = e.target;

        if (scrollTop >= 100) {
            setpos(true);
        } else {
            setpos(false);
        }
    }

    
    function playPause() {
        
        if (player?.current?.paused) {
            setplaying(true);
            player.current?.play();
        } else {
            console.log(player?.current?.paused);
            player.current?.pause();
            setplaying(false);
        }
    }

    let ext = "";
    if (site?.media && site?.media[0]) {
        ext = site?.media[0]?.split(".").pop();
    }
    // function BackMedia() {

        

    //     if (site?.media && site?.media[0]) {
            
            
    //         if (ext == "mp4") {
    //             return (
    //                 <>
    //                     <a tabIndex='0' onClick={playPause} className='pauseBox'>
    //                         {playing ? 
    //                             <icons.MdPause />
    //                         :
    //                             <icons.MdPlayArrow />
    //                         }
    //                     </a>
                        
    //                     <video ref={player} src={Config?.imgUrl + site?.media[0]} className="siteVid backgroundVideo" playsInline muted autoPlay loop></video>
    //                 </>
    //             );
    //         } else {
    //             return (
    //                 <Img src={site?.media[0]} className="siteVid backgroundVideo" playsInline muted autoPlay loop />
    //             );
    //         }
    //     }
    // }

    useEffect(() => {
        if (site?.colors) {
            Object.keys(site?.colors)?.map(k => {
                let val = site?.colors[k];
                document.documentElement.style.setProperty(k, val);
            });
        }
    }, [])
    
    let splitLocation = location?.pathname?.split("/").pop();
    let pathname = params?.id;

    if (splitLocation == encodeURI(pathname)) {
        pathname = "/";
    } else {
        if (splitLocation) {
            pathname = "/" + splitLocation;
        } else {
            pathname = "/";
        }
    }
    
    
    return (
        <>

        {pathname == "/" && 
            <div style={{position:"relative"}}>
                {ext == "mp4" ? 
                    <>

                        <video ref={player} src={Config?.imgUrl + site?.media[0]} className="siteVid backgroundVideo" playsInline muted autoPlay loop></video>
                    </>
                :
                     <Img src={site?.media[0]} className="siteVid backgroundVideo" playsInline muted autoPlay loop />
                }
            </div>
            // <BackMedia />
        }

        <section onScroll={onScroll} className={`main siteBody ${pos ? "float_menu" : "nope"}`}>
            
            {pathname == "/" && <a tabIndex='0' onClick={playPause} className='pauseBox'>
                {playing ? 
                    <icons.MdPause />
                :
                    <icons.MdPlayArrow />
                }
            </a>}

            <Header main_article={main_article}/>

                {children}

            <Footer />

        </section>

        </>
    )
}
